import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoyaltyProgramEffects } from './store/effects/loyalty-program.effects';
import { loyaltyProgramReducer } from './store/reducers/loyalty-program.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('loyaltyProgram', loyaltyProgramReducer),
    EffectsModule.forFeature([LoyaltyProgramEffects]),
  ],
})
export class LoyaltyProgramModule {}
